<template>
    <!-- client -->
    <span
        v-if="acks !== null && acks !== undefined"
        class="rouded-full"
        :class="{
            'ml-1':
                ml &&
                (ninguémConfirmouRecebimento ||
                    peloMenosUmaConfiguraçãoDeRecebimentoMasNinguémConfirmouLeitura ||
                    acksNormalizados.length > 0),
        }"
    >
        <WhatsappCheck class="w-3 h-3" v-if="ninguémConfirmouRecebimento" />

        <WhatsappDoubleCheck
            class="w-3 h-3"
            v-else-if="peloMenosUmaConfiguraçãoDeRecebimentoMasNinguémConfirmouLeitura"
        />

        <span v-else class="flex items-center flex-shrink-0 ml-1">
            <span
                class="-ml-1 w-4 h-4"
                v-for="({ chave, ack }, index) in acksNormalizados.slice(0, this.maxAcks)"
                :key="chave"
                :style="'z-index:' + index + 1"
            >
                <img v-if="chave != 'whatsapp'" v-show="ack == 2" :src="urlAvatarAck(chave)" class="rounded-full" />
            </span>

            <span v-if="acksNormalizados.length > this.maxAcks" class="ml-1 opacity-75 text-sm">
                {{ __('+:n', { n: acksNormalizados.length - this.maxAcks }) }}
            </span>
        </span>
    </span>
</template>


<script>
import WhatsappCheck from '@App/Vue/Remote/Chat/Eventos/Acks/WhatsappCheck.vue'
import WhatsappDoubleCheck from '@App/Vue/Remote/Chat/Eventos/Acks/WhatsappDoubleCheck.vue'

export default {
    components: { WhatsappCheck, WhatsappDoubleCheck },
    props: ['acks', 'perfil', 'ml'],
    computed: {
        maxAcks() {
            return 5
        },

        /**
         * A mensagem pode passar pelos seguintes estados:
         * -> Enviando (relógio)
         * -> Enviado mas ninguém confirmou recebimento ainda (um check)
         * -> Enviado e pelo menos uma pessoa confirmou recebimento (dois checks)
         * -> Enviado e pelo menos uma pessoa confirmou leitura (lista de avatar)
         */
        acksNormalizados() {
            let acks = []
            let keys = Object.keys(this.acks || {})

            keys.forEach((chave) => {
                if (['whatsapp'].indexOf(chave) !== -1) return

                // Temporário, remover depois.
                // Se você está lendo isso depois de 01/06/2021 pode remover esse "if".
                if (chave.indexOf('core_usuários') !== -1 || chave.indexOf('crm_contatos') !== -1) return

                // Se for ack de contatos desconhecidos (como contatos em uma lista de transmissão do whatsapp), ignorar.
                if (chave.indexOf('core_users:') === -1 && chave.indexOf('crm_contacts:') === -1) return

                if (!this.acks) return
                acks.push({ chave: chave, ack: this.acks[chave] })
            })

            return acks
        },

        ninguémConfirmouRecebimento() {
            return Object.keys(this.acks || {}).length == 0
        },

        peloMenosUmaConfiguraçãoDeRecebimentoMasNinguémConfirmouLeitura() {
            return this.recebimentos.length > 0 && this.leituras.length == 0
        },

        recebimentos() {
            return Object.keys(this.acks || {}).filter((key) => {
                return this.acks[key] == 1 || key == 'whatsapp'
            })
        },

        leituras() {
            return Object.keys(this.acks || {}).filter((key) => {
                return this.acks[key] == 2
            })
        },
    },
    methods: {
        urlAvatarAck(chave) {
            return this.perfil(chave).url_avatar_32px
        },
    },
}
</script>